import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/bigData`);

export default class BigDataService {
  axios: typeof axiosInstance;

  constructor() {
    this.axios = axiosInstance;
  }

  solicitaBigData(cpf: string, idProposta: string, idusuario: string, tipoConsulta: string): void {
    this.axios.post(`/solicitar/${tipoConsulta}`, {
      cpf,
      idProposta,
      idusuario
    }).catch((error: any) => {
      console.error('Erro ao solicitar BigData:', error);
    });
  }

  async consultaSincrona(cpf: string, idProposta: string | null, idusuario: string, tipoConsulta: string): Promise<any> {
    try {
      const payload: any = { cpf, idusuario };
      if (idProposta) {
        payload.idProposta = idProposta;
      }
      const response = await this.axios.post(`/consultaSincrona/${tipoConsulta}`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro na consulta síncrona:', error);
      throw error;
    }
  }

    async geraRelatorioPdf(idProposta: string, tipoPdf: number, idBureau: number): Promise<Blob> {
    try {
        const response = await this.axios.post(
        '/gerarPdf', 
        { idProposta, tipoPdf, idBureau },
        {
            responseType: 'blob', // Isso é crucial para receber PDF/binários
        }
        );
        return new Blob([response.data], { type: 'application/pdf' });
    } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        throw error;
    }
    }

  async consultarDossie(idProposta: string): Promise<any> {
    return await this.axios.get(`/consultar/${idProposta}`);
  }

  async consultarPorCpf(cpf: string): Promise<any> {
    try {
        const response = await this.axios.get('/consultarPorCpf', {
        params: { cpf },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao consultar por CPF na BigData:', error);
        throw error;
    }
  }

  async consultarPassivelDeAnalise(idProposta: number): Promise<boolean> {
    try {
        const response = await this.axios.get('/consultarPassivelDeAnalise', {
        params: { idProposta },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao consultar passivel de analise:', error);
        throw error;
    }
  }

  async gerarPdfPorCpf(cpf: string): Promise<Blob> {
    try {
      const response = await this.axios.get(`/pdf/${cpf}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      });
      return new Blob([response.data], { type: 'application/pdf' });
    } catch (error) {
      console.error('Erro ao gerar PDF por CPF:', error);
      throw error;
    }
  }

  async gerarCsvPorCpf(cpf: string): Promise<Blob> {
    try {
      const response = await this.axios.get(`/csv/${cpf}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'text/csv'
        }
      });
      return new Blob([response.data], { type: 'text/csv' });
    } catch (error) {
      console.error('Erro ao gerar CSV por CPF:', error);
      throw error;
    }
  }

}
